import script from "./MainMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainMap.vue?vue&type=script&setup=true&lang=ts"

import "./MainMap.vue?vue&type=style&index=0&id=08dec6bd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08dec6bd"]])

export default __exports__